/**
 * FileMaker Plugins for FMwvTool
 * 
 * Collection of plugins for working with FileMaker scripts and objects
 * 
 * SELF-REGISTRATION:
 * These plugins register themselves with PluginRegistry on import
 */

import { registerPlugin } from '../../PluginRegistry';
import { fileMakerPrintableToXMLPlugin } from './FileMakerPrintableToXML';
import { fileMakerXMLToClipboardPlugin } from './FileMakerXMLToClipboard';
import { fmwvToolScriptConverterPlugin } from './FMwvToolScriptConverter';

// Register FileMaker plugins
registerPlugin({
  id: 'filemaker/FileMakerPrintableToXML',
  name: 'FM Printable → XML',
  description: 'Convert FileMaker printable script steps to XML format',
  category: 'filemaker-scripts',
  version: '1.0.0',
  author: 'OpCentral',
  tags: ['filemaker', 'scripts', 'xml', 'conversion'],
  hasComponent: false,
  loader: async () => fileMakerPrintableToXMLPlugin
});

registerPlugin({
  id: 'filemaker/FileMakerXMLToClipboard',
  name: 'FM XML → Clipboard',
  description: 'Convert FileMaker XML to clipboard-ready script steps',
  category: 'filemaker-scripts',
  version: '1.0.0',
  author: 'OpCentral',
  tags: ['filemaker', 'scripts', 'xml', 'clipboard'],
  hasComponent: false,
  loader: async () => fileMakerXMLToClipboardPlugin
});

registerPlugin({
  id: 'filemaker/FMwvToolScriptConverter',
  name: 'FMwvTool Script Converter',
  description: 'Convert FMwvTool scripts between formats',
  category: 'filemaker-scripts',
  version: '1.0.0',
  author: 'OpCentral',
  tags: ['filemaker', 'scripts', 'conversion'],
  hasComponent: false,
  loader: async () => fmwvToolScriptConverterPlugin
});

// Export plugins
export * from './FileMakerPrintableToXML';
export * from './FileMakerXMLToClipboard';
export * from './FMwvToolScriptConverter';
export * from './FileMakerObjectClipperPlugin';

export { fileMakerPrintableToXMLPlugin } from './FileMakerPrintableToXML';
export { fileMakerXMLToClipboardPlugin } from './FileMakerXMLToClipboard';
export { fmwvToolScriptConverterPlugin } from './FMwvToolScriptConverter';
export { fileMakerObjectClipperPlugin } from './FileMakerObjectClipperPlugin';
